import {
    AVAILABLE_TICKET_STATUS,
    ON_SALE,
} from '../../containers/ticketSelection/constants';
import { Ticket, TicketStatus, TicketVariant } from '../../models/tickets';
import { CheckoutState } from '../../state';
import { getIsAppRebrandActive } from '../app/getIsAppRebrandActive';
import { getTicketsById } from './pureSelectors';

export const isTicketSection = (ticket: Ticket): boolean => {
    return (
        ticket.variantInputType === 'multiple' &&
        ticket.minimumQuantity == null &&
        ticket.ticketOptionsRange?.length === 0
    );
};

export const flattenTicketSections = (
    tickets: Ticket[],
): (Ticket | TicketVariant)[] =>
    tickets
        .map((ticket) => {
            if (isTicketSection(ticket)) {
                return ticket.variants;
            }
            return ticket;
        })
        .flat();

export const areQuantitySelectorsHidden = (state: CheckoutState): boolean => {
    const ticketsById = getTicketsById(state);
    const tickets = flattenTicketSections(Object.values(ticketsById));

    if (tickets.length === 0) {
        return false;
    }

    const ticketsWithVisibleSelectors = tickets.filter((ticket) => {
        const hasTicketOptionsRange =
            ticket.ticketOptionsRange && ticket.ticketOptionsRange.length > 0;

        if (hasTicketOptionsRange) {
            return (
                ticket.onSaleStatus === ON_SALE ||
                ticket.onSaleStatus === AVAILABLE_TICKET_STATUS
            );
        }

        const ticketStatus = ticket.statusKey as TicketStatus;
        if (!ticketStatus) {
            return false;
        }

        const STATUSES_WITH_VISIBLE_SELECTORS = [
            TicketStatus.onSale,
            TicketStatus.salesEndSoon,
        ];

        if (STATUSES_WITH_VISIBLE_SELECTORS.includes(ticketStatus)) {
            return true;
        }

        if (ticketStatus === TicketStatus.soldOut) {
            return !getIsAppRebrandActive(state);
        }

        const STATUSES_WITH_HIDDEN_SELECTORS = [
            TicketStatus.salesEnded,
            TicketStatus.salesStartAfter,
            TicketStatus.unavailable,
            TicketStatus.salesNotStarted,
            TicketStatus.salesStartSoon,
        ];

        return !STATUSES_WITH_HIDDEN_SELECTORS.includes(ticketStatus);
    });

    return ticketsWithVisibleSelectors.length === 0;
};
